package maplibreGL.renderer

import apiclient.geoobjects.LatLon
import apiclient.geoobjects.ObjectType
import dev.fritz2.core.Id
import koin.koinCtx
import maplibreGL.FormationMap
import maplibreGL.MaplibreMarkerOptions
import maplibreGL.Marker
import maplibreGL.toJs
import maplibreGL.toLngLat
import mapsearch.MarkerGenerators.makeSvgMarkerForMap
import org.w3c.dom.events.EventListener
import svgmarker.SvgIconOptions
import theme.FormationIcons

class TemporaryMarkerRender {

    val formationMap: FormationMap by koinCtx.inject()

    val map get() = formationMap.map

    private var coordinatePointers: MutableMap<String, Marker> = mutableMapOf()

    fun insertTemporaryMarker(title: String, coordinates: LatLon) {
        val newId = "coordinate-${Id.next(9)}"
        val renderContext = formationMap.getMapRenderContext() ?: return

        val svgIconOptions = SvgIconOptions(
            icon = FormationIcons.Location,
        )

        val coordinateMarkerEventListener = EventListener { event ->
            event.stopPropagation()
            coordinatePointers[formationMap.getTargetElementIdFromEvent(event)]?.remove()
        }

        val markerOptions = MaplibreMarkerOptions(
            element = makeSvgMarkerForMap(
                id = newId,
                title = title,
                svgIconOptions = svgIconOptions,
                objectType = ObjectType.POI,
                active = false,
                showTitle = true,
            ).also { element ->
                element.addEventListener("click", coordinateMarkerEventListener)
            },
        )

//        val markerOptions = MaplibreMarkerOptions(
//            element = getDomElement(newId, renderContext) {
//                makeSvgMarker(
//                    objectId = newId,
//                    objectType = ObjectType.POI,
//                    title = title,
//                    svgIconOptions = svgIconOptions,
//                    active = false,
//                    showTitle = true,
//                )
//            }.also { element ->
//                element.addEventListener("click", coordinateMarkerEventListener)
//            },
//        )
        val marker = Marker(markerOptions.toJs())
        marker.setLngLat(coordinates.toLngLat())
        coordinatePointers[newId] = marker
        marker.addTo(map)
    }
}
